"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/modal/style");
var _modal = _interopRequireDefault(require("antd/lib/modal"));
var _react = _interopRequireWildcard(require("react"));
var _dailyJs = _interopRequireDefault(require("@daily-co/daily-js"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRouterDom = require("react-router-dom");
var _utils = require("../../utils");
var _api = require("./api");
require("./GroupVideo.less");
var _GroupChats = require("../GroupChats");
var _lodash = require("lodash");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
var confirm = _modal.default.confirm;
var DAILYCO_IFRAME_WIDTH = {
  DEFAULT: '100%',
  DESKTOP_CHAT_ACTIVE: 'calc(100% - 350px)'
};
var destroyDailyCallInstanceIfExists = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var currentInstance;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            currentInstance = _dailyJs.default.getCallInstance();
            if (currentInstance) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            _context.next = 5;
            return currentInstance.destroy();
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function destroyDailyCallInstanceIfExists() {
    return _ref.apply(this, arguments);
  };
}();
var GroupVideo = function GroupVideo(props) {
  var baseVideoUrl = props.baseVideoUrl,
    groupId = props.groupId,
    groupSessionId = props.groupSessionId,
    dailyRoomName = props.dailyRoomName,
    token = props.token,
    viewerRole = props.viewerRole,
    activeSession = props.activeSession,
    _props$leaveCallRedir = props.leaveCallRedirectPathname,
    leaveCallRedirectPathname = _props$leaveCallRedir === void 0 ? _utils.PATIENT_COMMUNITY_CHAT_URL : _props$leaveCallRedir,
    chatClient = props.chatClient,
    globalBan = props.globalBan,
    owner = props.owner;
  var history = (0, _reactRouterDom.useHistory)();
  var callFrameRef = (0, _react.useRef)();
  var _useCssMedia = (0, _utils.useCssMedia)(),
    sm = _useCssMedia.sm,
    md = _useCssMedia.md,
    lg = _useCssMedia.lg;
  (0, _react.useEffect)(function () {
    if (token) {
      setupGroupVideoCall();
    }
  }, [token]);
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    nextDestination = _useState2[0],
    setNextDestination = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = _slicedToArray(_useState3, 2),
    chatVisible = _useState4[0],
    setChatVisible = _useState4[1];

  // useChatAutoClose(chatVisible, setChatVisible, baseVideoUrl);

  var handleExitPage = function handleExitPage(nextLocation) {
    confirmLeaveSession(nextLocation);
    return false;
  };
  var confirmLeaveSession = function confirmLeaveSession(nextLocation) {
    confirm({
      className: 'group-video-modal',
      centered: true,
      title: 'Are you sure you want to leave this group session?',
      cancelText: 'Cancel',
      cancelButtonProps: {
        type: 'default',
        size: 'large'
      },
      okText: 'Leave',
      okButtonProps: {
        type: 'primary',
        size: 'large'
      },
      onOk: function onOk() {
        setNextDestination(nextLocation);
      }
    });
  };
  (0, _react.useEffect)(function () {
    if (nextDestination) {
      history.push(nextDestination.pathname, nextDestination.state);
    }
  }, [nextDestination]);

  // As per design request, we're setting new iframe width on desktop only, if chat is visible and
  // turn it back to default, when the user closes it using corresponding actions
  (0, _react.useEffect)(function () {
    if (!(0, _utils.isMobileOrTablet)() && callFrameRef.current) {
      if (chatVisible) {
        callFrameRef.current._iframe.style.width = DAILYCO_IFRAME_WIDTH.DESKTOP_CHAT_ACTIVE;
      } else {
        callFrameRef.current._iframe.style.width = DAILYCO_IFRAME_WIDTH.DEFAULT;
      }
    }
  }, [chatVisible]);
  var shouldPollRoles = [_utils.UserRoles.Patient, _utils.UserRoles.Therapist];
  var shouldPollAttendance = (0, _lodash.includes)(shouldPollRoles, viewerRole) && !!activeSession;
  (0, _api.usePollAttendance)(shouldPollAttendance, groupId);
  var _useJoinSupportGroupC = (0, _api.useJoinSupportGroupChat)(chatClient, groupId),
    isMember = _useJoinSupportGroupC.isMember;
  var setupGroupVideoCall = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var iframeStyle, parentElement, defaultGroupCallSettings, callFrame;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              iframeStyle = {
                width: DAILYCO_IFRAME_WIDTH.DEFAULT,
                height: '100%',
                flex: '1',
                border: 'none'
              };
              parentElement = document.querySelector('.group-video-container');
              defaultGroupCallSettings = {
                showLeaveButton: true,
                iframeStyle: iframeStyle,
                token: token
              }; // Using flexible settings here to lessen the load on smaller screen devices
              // Won't change on screen resize, since these are Daily Prebuilt iframe init settings
              if (sm) {
                defaultGroupCallSettings.layoutConfig = {
                  grid: {
                    maxTilesPerPage: lg ? 24 : md ? 20 : 16,
                    minTilesPerPage: lg ? 20 : md ? 16 : 12
                  }
                };
              }

              // In new 'daily-js' dependency versions, callFrame.destroy() method is async
              // So we check, if the instance already exists and destroy it before creating a new one
              _context2.next = 6;
              return destroyDailyCallInstanceIfExists();
            case 6:
              callFrame = _dailyJs.default.createFrame(parentElement, defaultGroupCallSettings);
              callFrame.join({
                url: "".concat(baseVideoUrl, "/").concat(dailyRoomName)
              });
              callFrame.on('left-meeting', function () {
                setNextDestination({
                  pathname: "".concat(leaveCallRedirectPathname, "/").concat(groupId),
                  state: {
                    source: 'GroupVideoEnd',
                    groupSessionId: groupSessionId
                  }
                });
              });
              callFrameRef.current = callFrame;
            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function setupGroupVideoCall() {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "group-video-container"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Prompt, {
    message: handleExitPage,
    when: !nextDestination
  }), /*#__PURE__*/_react.default.createElement(_GroupChats.SingleGroupChatWidget, {
    chatClient: chatClient,
    globalBan: globalBan,
    groupId: groupId,
    isChatRendered: isMember,
    isChatVisible: chatVisible,
    setIsChatVisible: setChatVisible,
    owner: owner
  }));
};
GroupVideo.propTypes = {
  baseVideoUrl: _propTypes.default.string,
  groupId: _propTypes.default.string,
  dailyRoomName: _propTypes.default.string,
  token: _propTypes.default.string,
  viewerRole: _propTypes.default.number,
  activeSession: _propTypes.default.object,
  owner: _propTypes.default.object
};
var _default = GroupVideo;
exports.default = _default;